export enum EventActionTypeEnum {
  // Appel à
  CALL_TO = 'CALL_TO',
  // Réception d'appel de
  CALL_RECEIVED = 'CALL_RECEIVED',
  // Envoi de mail à
  EMAIL_TO = 'EMAIL_TO',
  // Réception de mail de
  EMAIL_RECEIVED = 'EMAIL_RECEIVED'
}

export const eventActionTypeEnumMapping: Record<EventActionTypeEnum, string> = {
  [EventActionTypeEnum.CALL_TO]: 'Appel à',
  [EventActionTypeEnum.CALL_RECEIVED]: "Réception d'appel de",
  [EventActionTypeEnum.EMAIL_TO]: "Envoi d'email à",
  [EventActionTypeEnum.EMAIL_RECEIVED]: "Réception d'email de"
}
